/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_IntroInputs */

const en_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore five decades of moments with champions, students, and the game.`)
};

const es_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora cinco décadas de momentos con campeones, alumnos y el juego.`)
};

const de_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecken Sie fünf Jahrzehnte voller Momente mit Champions, Studenten und dem Spiel.`)
};

const zh_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索与冠军、学生和比赛一起度过的五个十年的时刻。`)
};

const ar_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استكشف خمسة عقود من اللحظات مع الأبطال والطلاب واللعبة.`)
};

const fr_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorez cinq décennies de moments avec les champions, les étudiants et le jeu.`)
};

const vi_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khám phá năm thập kỷ khoảnh khắc với các nhà vô địch, học viên, và môn chơi.`)
};

const sw_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gundua miongo mitano ya matukio na mabingwa, wanafunzi na mchezo.`)
};

const th_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำรวจช่วงเวลาห้าทศวรรษกับแชมป์เปี้ยน นักเรียน และเกม`)
};

const bs_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istražite pet decenija trenutaka sa šampionima, učenicima i igrom.`)
};

const ja_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チャンピオン、教え子、そしてゴルフと歩んだ50年の瞬間をご覧ください。`)
};

const ko_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`챔피언, 학생 및 게임으로 5 년의 순간을 탐험하십시오.`)
};

const pt_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore cinco décadas de momentos com campeões, estudantes e o jogo.`)
};

const it_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora cinque decenni di momenti con campioni, studenti e il gioco.`)
};

const sv_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforska fem decennier av ögonblick med mästare, studenter och spelet.`)
};

const nl_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verken vijf decennia van momenten met kampioenen, studenten en het spel.`)
};

const da_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udforsk fem årtiers øjeblikke med mestre, studerende og spillet.`)
};

const nb_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforsk fem tiår av øyeblikk med mestere, studenter og spillet.`)
};

const fi_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutki viisi vuosikymmentä hetkiä mestareiden, opiskelijoiden ja pelin.`)
};

const pl_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznaj pięć deDwadzieścia momentów z mistrzami, studentami i grą.`)
};

const ru_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исследуйте пять десятилетий моментов с чемпионами, студентами и игрой.`)
};

const tr_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şampiyonlar, öğrenciler ve oyunla birlikte beş on yıl anı keşfedin.`)
};

const hi_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चैंपियन, छात्रों और खेल के साथ पांच दशकों के क्षणों का अन्वेषण करें।`)
};

const id_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menjelajahi lima dekade momen dengan juara, siswa, dan permainan.`)
};

const ms_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terokai lima dekad detik bersama para juara, pelajar dan permainan golf.`)
};

const cs_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozkoumejte pět desetiletí momentů s šampiony, studenty a hru.`)
};

const el_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εξερευνήστε πέντε δεκαετίες στιγμές με πρωταθλητές, μαθητές, και το παιχνίδι.`)
};

const he_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חקור חמישה עשורים של רגעים עם אלופים, סטודנטים, ואת המשחק.`)
};

const af_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verken vyf dekades se oomblikke met kampioene, studente en die spel.`)
};

const hu_hof_intro = /** @type {(inputs: Hof_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fedezze fel öt évtizednyi pillanat bajnokok, diákok, és a játék.`)
};

/**
* | output |
* | --- |
* | "Explore five decades of moments with champions, students, and the game." |
*
* @param {Hof_IntroInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_intro = /** @type {((inputs?: Hof_IntroInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_IntroInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_intro(inputs)
	if (locale === "de") return de_hof_intro(inputs)
	if (locale === "zh") return zh_hof_intro(inputs)
	if (locale === "ar") return ar_hof_intro(inputs)
	if (locale === "fr") return fr_hof_intro(inputs)
	if (locale === "vi") return vi_hof_intro(inputs)
	if (locale === "sw") return sw_hof_intro(inputs)
	if (locale === "th") return th_hof_intro(inputs)
	if (locale === "bs") return bs_hof_intro(inputs)
	if (locale === "ja") return ja_hof_intro(inputs)
	if (locale === "ko") return ko_hof_intro(inputs)
	if (locale === "pt") return pt_hof_intro(inputs)
	if (locale === "it") return it_hof_intro(inputs)
	if (locale === "sv") return sv_hof_intro(inputs)
	if (locale === "nl") return nl_hof_intro(inputs)
	if (locale === "da") return da_hof_intro(inputs)
	if (locale === "nb") return nb_hof_intro(inputs)
	if (locale === "fi") return fi_hof_intro(inputs)
	if (locale === "pl") return pl_hof_intro(inputs)
	if (locale === "ru") return ru_hof_intro(inputs)
	if (locale === "tr") return tr_hof_intro(inputs)
	if (locale === "hi") return hi_hof_intro(inputs)
	if (locale === "id") return id_hof_intro(inputs)
	if (locale === "ms") return ms_hof_intro(inputs)
	if (locale === "cs") return cs_hof_intro(inputs)
	if (locale === "el") return el_hof_intro(inputs)
	if (locale === "he") return he_hof_intro(inputs)
	if (locale === "af") return af_hof_intro(inputs)
	if (locale === "hu") return hu_hof_intro(inputs)
	return en_hof_intro(inputs)
});